import { combineEpics } from 'redux-observable';
import { toggleUnmappedSymbolsEpic } from './_epics/toggleUnmappedSymbols.epic';

export const unmappedSymbolsToggleEpic = combineEpics(
  toggleUnmappedSymbolsEpic,
);
